import React, { Component } from "react";

import ToolsSelect from "../clients/Tools/kit/ToolsSelect";
import ToolsCheckbox from "../clients/Tools/kit/ToolsCheckbox";
import PlaybookInputFieldService from "../../services/PlaybookInputFieldService";
import UtilityService from "../../services/UtilityService";

import "./playbook-input-fields-form.css";

const MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

class PlaybookInputFieldsForm extends Component {
	onValueChanged = ({ key, value }) => {
		this.props.onChange({ key, value });
	};

	onAmountLeft = ({ field }) => {
		if (field.kind !== "money") return;
		const { values } = this.props;
		const key = field.key;
		const typedText = String(values[key] === undefined || values[key] === null ? "" : values[key]).trim();
		const isBracketed = typedText.startsWith("(") && typedText.endsWith(")");
		const unbracketed = isBracketed ? typedText.slice(1, -1) : typedText;
		const bareText = unbracketed.replace(/[$,\s]/g, "");
		const isPlainNumber = /^-?(\d+(\.\d+)?|\.\d+)$/.test(bareText);
		if (!isPlainNumber) return;
		const amount = Number(bareText);
		const signedAmount = isBracketed ? -Math.abs(amount) : amount;
		const shownAmount = UtilityService.formatCurrency(signedAmount);
		this.onValueChanged({ key, value: shownAmount });
	};

	optionsFor = ({ field }) => {
		const isMonth = field.kind === "month";
		const choices = field.choices || [];
		const monthOptions = MONTH_NAMES.map((monthName, index) => ({ value: String(index + 1), label: monthName }));
		const choiceOptions = choices.map(choice => ({ value: String(choice), label: PlaybookInputFieldService.describeFieldValue({ field, value: choice }) }));
		const listedOptions = isMonth ? monthOptions : choiceOptions;
		if (field.isRequired) return listedOptions;
		const defaultValue = field.defaultValue;
		const hasDefault = !(defaultValue === undefined || defaultValue === null || String(defaultValue).trim() === "");
		const defaultOption = hasDefault ? listedOptions.find(option => option.value === String(defaultValue).trim()) : null;
		const shownDefault = defaultOption ? defaultOption.label : String(defaultValue);
		const clearLabel = hasDefault ? `Default (${shownDefault})` : "Not given";
		const clearOption = { value: "", label: clearLabel };
		const optionsWithClear = [clearOption, ...listedOptions];
		return optionsWithClear;
	};

	renderEditor = ({ field, editor }) => {
		const { values, disabled } = this.props;
		const key = field.key;
		const rawValue = values[key];
		const value = rawValue === undefined || rawValue === null ? "" : rawValue;

		if (editor === "amount") {
			return (
				<input
					type="text"
					inputMode="decimal"
					className="tk-input playbook-input-fields-form__amount"
					value={value}
					disabled={!!disabled}
					onChange={event => this.onValueChanged({ key, value: event.target.value })}
					onBlur={() => this.onAmountLeft({ field })}
				/>
			);
		}
		if (editor === "select") {
			const shownValue = String(value);
			const options = this.optionsFor({ field });
			return <ToolsSelect value={shownValue} options={options} disabled={!!disabled} onChange={chosen => this.onValueChanged({ key, value: chosen })} />;
		}
		if (editor === "checkbox") {
			const isTicked = value === true;
			return (
				<ToolsCheckbox
					size="form"
					label="Yes"
					checked={isTicked}
					disabled={!!disabled}
					onChange={event => this.onValueChanged({ key, value: event.target.checked })}
				/>
			);
		}
		if (editor === "date") {
			return <input type="date" className="tk-input" value={value} disabled={!!disabled} onChange={event => this.onValueChanged({ key, value: event.target.value })} />;
		}
		return <input type="text" className="tk-input" value={value} disabled={!!disabled} onChange={event => this.onValueChanged({ key, value: event.target.value })} />;
	};

	renderField = field => {
		const editor = PlaybookInputFieldService.editorFor({ kind: field.kind });
		if (!editor) return null;
		const fieldClassName = field.help ? "tk-form-field playbook-input-fields-form__field--wide" : "tk-form-field";

		return (
			<div key={field.key} className={fieldClassName}>
				<div className="tk-form-label">
					{field.label}
					{field.isRequired && <span className="tk-form-required">*</span>}
				</div>
				{this.renderEditor({ field, editor })}
				{field.help && <div className="tk-form-help">{field.help}</div>}
			</div>
		);
	};

	render() {
		const { fields } = this.props;
		const declaredFields = fields || [];
		if (declaredFields.length === 0) return null;

		return <div className="playbook-input-fields-form">{declaredFields.map(this.renderField)}</div>;
	}
}

export default PlaybookInputFieldsForm;
